import { useContext, useEffect } from "react";
import { ConfigProvider, theme } from "antd";
import AppContext from "../store/app.context";
import locale from "antd/locale/id_ID";

interface ThemeProviderProps {
	children: React.ReactNode;
}

export const ThemeProvider = ({ children }: ThemeProviderProps) => {
	const { theme: currentTheme } = useContext(AppContext);

	const { darkAlgorithm, defaultAlgorithm } = theme;

	// Add/remove theme class from body
	useEffect(() => {
		document.body.className = document.body.className.replace(/\b(light-theme|dark-theme)\b/g, "");
		document.body.classList.add(`${currentTheme}-theme`);
	}, [currentTheme]);

	return (
		<ConfigProvider
			locale={locale}
			theme={{
				algorithm: currentTheme === "dark" ? darkAlgorithm : defaultAlgorithm,
				token: {
					colorPrimary: "#01ABE9",
					colorSuccess: "#29D697",
					colorWarning: "#FFC107",
					colorError: "#F2583E",
					fontFamily: "Geist, sans-serif",
					borderRadius: 2,
					colorBorder: currentTheme === "dark" ? "#343434FF" : "#EFEFEFFF",
					colorBorderBg: currentTheme === "dark" ? "#343434FF" : "#EFEFEFFF",
					colorBorderSecondary: currentTheme === "dark" ? "#343434FF" : "#EFEFEFFF",
					colorBgBase: currentTheme === "dark" ? "#1a1a1a" : "#ffffff",
					colorBgContainer: currentTheme === "dark" ? "#262626" : "#ffffff",
					colorBgLayout: currentTheme === "dark" ? "#212121FF" : "#f5f5f5",
					colorText: currentTheme === "dark" ? "#e8e8e8" : "#262626",
					colorTextSecondary: currentTheme === "dark" ? "#bfbfbf" : "#8c8c8c",
				},
			}}>
			{children}
		</ConfigProvider>
	);
};
